module.exports = __webpack_public_path__ + "img/401.43d53d98.png";